import { createAction } from '@ngrx/store';


export const shrink = createAction("shrink");
export const expand = createAction("expand");


